/**
 * User: daletan
 * Date: 11/20/14
 * Time: 4:24 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

'use strict';

var $ = require('dibs-jquery-shim');
var queryService = (function () {
    var qsType = {
        xml: '',
        json: 'json'
    };

    /**
     * @param type - String  either 'json' or 'xml'
     * @param name - String - name of query service
     * @param params - Object - key/value pairs to pass to the queryservice
     * @return {Object} property base (with no query params) or full (with all query params)
     */
    function url(type, name, params) {
        var qsFormat = qsType[type] || 'json'; // on client json is the default
        var qsBase = '/soa/queryservice/' + qsFormat + '/' + name + '.dibs';
        var parts = [];

        params = params || {};

        $.each(params, function (key, value) {
            parts.push(key + '=' + value);
        });

        return {
            base: qsBase,
            full: qsBase + (parts ? '?' + parts.join('&') : '')
        };
    }

    /**
     * @description Ensures queryservice[name].row is an array
     * @param row
     * @return Array
     */
    function normalizeRow(row) {
        row = row || [];
        return $.isArray(row) ? row : [row];
    }

    /**
     * @description Converts composed query results into one array
     * @param rows An array of arrays
     * @return Array flattened into one row
     */
    function normalizeComposedQ(rows) {
        var merge = [];
        var i;
        var item;
        var key;
        var row;

        for (i = 0; i < rows.length; i++) {
            item = rows[i];
            for (key in item) {
                if (item.hasOwnProperty(key)) {
                    row = item[key].row;
                    if ($.isArray(row)) {
                        merge = [].concat.apply(merge, row);
                    } else if (typeof row === "object") {
                        merge.push(row);
                    }
                    break;  //we're only interested in the first property
                }

            }
        }
        return merge;
    }

    /**
     *
     * @param type -- the response type, xml or json
     * @param name -- query service query name
     * @param params -- object key/value of params to pass
     * @return Object jQuery.Deferred.promise
     */
    function get(type, name, params) {
        var dfd = $.Deferred();
        var error = {
            error:      true,
            status:     500,
            statusText: ''
        };
        var xhr;

        params = params || {};

        if (window.bypassCache) {
            params.bypassCache = true;
        }

        if (!qsType[type]) {
            // log the error, but set format to json
            console.log('global.DIBS.queryService', 'Type: "' + type + '" not recognized. Using json...');
            type = 'json';
        }

        xhr = $.ajax({
            url:      url(type, name).base,
            data:     params,
            dataType: type
        });

        xhr.done(function (result) {
            if (result[name]) {
                if (params.type === 'composed') {
                    dfd.resolve(normalizeComposedQ(result[name]));
                } else {
                    dfd.resolve(normalizeRow(result[name].row));
                }
            } else {
                error.status = 500;
                error.statusText = "Malformed Queryservice result.";
                dfd.reject(error);
            }
        });

        xhr.fail(function (jqxhr) {
            error.status = jqxhr.status;
            error.statusText = jqxhr.responseText.substring(0, 128);
            dfd.reject(error);
        });

        return dfd.promise();
    }

    return {
        xmlUrl: function (name, params) {
            return url('xml', name, params);
        },

        jsonUrl: function (name, params) {
            return url('json', name, params);
        },

        xml: function (name, params) {
            return get('xml', name, params);
        },

        json: function (name, params) {
            return get('json', name, params);
        }
    };
}());

module.exports = queryService;



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/modules/queryService.js
// module id = 2524
// module chunks = 63